module.exports = __webpack_public_path__ + "img/title-2.9f43bf74.png";